import { useEffect,useRef,useState } from 'react';
import BubbleChat from './BubbleChat/BubbleChat'
import { useConversationStateContext, useConversationDispatchContext } from "../../../context/ConversationContext"
import { useChatboxStateContext } from '../../../context/ChatboxContext'
import useSpeechSynthesis from '/src/hooks/useSpeechSynthesis';
import bipSound from '../../../assets/mp3/ring.mp3';
const ChatContent = () => {
    const dispatch = useConversationDispatchContext();
    const [ voices, speak ] = useSpeechSynthesis();
    const { data, avatar, language, mode, sound_effect} = useConversationStateContext();
    const { valueOpen } = useChatboxStateContext();
    const { messages } = data;
    const [audioPlayed, setAudioPlayed] = useState(false);

    const { valueToggleSound } = useChatboxStateContext();
    
    const indexLastMessageNotView = messages.findIndex(message => message.view == 0)
    const displayMessage = () => dispatch({ type : 'displayMessage', payload : { index : indexLastMessageNotView}})

    const actionOnMessage = () => {
        const messageNotView = messages[indexLastMessageNotView];
        displayMessage()
        
        const voicesFilterByLanguage = voices.filter(voice => voice.lang.includes(language.slug));
        const voice = voicesFilterByLanguage.filter(voice => voice.default).shift() || voicesFilterByLanguage.shift();
        if(valueToggleSound == false || voice == undefined || messageNotView.type != "text") return
        speak(messageNotView.content, voice);
    
    }
    const timerRunningRef = useRef(true);
    useEffect(() => {
        if (indexLastMessageNotView !== -1) {
          const timerId = setTimeout(() => {
            actionOnMessage();
            if (timerRunningRef.current && !audioPlayed) {
              if (mode !== "debug" && !valueOpen && sound_effect) {
                const audio = new Audio(bipSound);
                audio.oncanplay = () => {
                  audio.play();
                  setAudioPlayed(true); 
                };
              }
            }
          }, 1200);

        const element = document.createElement('style');
        const isPngLink = avatar.includes('.png');
        let modifiedAvatar = avatar;
        if(!isPngLink) {
          modifiedAvatar = `data:image/svg+xml;base64,${window.btoa(avatar)}`;
        }
 
        document.head.appendChild(element).innerHTML = `.kwalys-chatbox-window .kwalys-chat #chat-content .bubbles.bot::before { background-image: url(${modifiedAvatar}); }`;
    
          return () => {
            clearTimeout(timerId);
          }
        }
    }, [indexLastMessageNotView, mode, valueOpen, audioPlayed ,avatar]);

    useEffect(() => {
        if (valueOpen) {
            timerRunningRef.current = false; 
        }
    }, [valueOpen]);
 
    var messagesRobotAndHuman = [];
    var messagesRobot = [];
    for(let message of messages) {
        if(message.type == 'human') {
            messagesRobotAndHuman.push(messagesRobot);
            messagesRobotAndHuman.push([message])
            messagesRobot = [];
            continue;
        }

        messagesRobot.push(message);
    }

    messagesRobotAndHuman.push(messagesRobot);
    messagesRobotAndHuman.reverse();

    return (
        <div id="chat-content"  className='scrollbar-chatbox'>
            {messagesRobotAndHuman && messagesRobotAndHuman.map( (dataSet, index) => {
                return (
                    <div className={index % 2 == 0 ? 'bubbles bot' : 'bubbles human'} key={index}>
                        {dataSet && dataSet.map((message, indexMessage) => message.view ? <BubbleChat {...message} key={indexMessage}  /> : null)}
                        {index == 0 && indexLastMessageNotView != -1 && index % 2 == 0 ?  <BubbleChat type="typing"/> : null}
                    </div>
                )
            })}
        </div>
    );
};
/*{index != -1 ? <BubbleChat type="typing"/> : null}*/
export default ChatContent;